import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { registerPlanAccessDenied } from "../Services/PlanAccessDeniedHelper";

export default function PlanAccessDeniedDialog() {
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();
  useEffect(() => registerPlanAccessDenied(() => setVisible(true)), []);

  return (
    <Dialog header="Access denied" visible={visible} onHide={() => setVisible(false)}
      style={{ width: "28rem" }} breakpoints={{ "640px": "90vw" }}
      footer={<Button label="Back to dashboard" onClick={() => { setVisible(false); navigate("/"); }} />}>
      <p>You don’t have permission to view or change this information. If you need access, contact your plan leader.</p>
    </Dialog>
  );
}
